export default __webpack_public_path__ + "static/media/JO.80e0b239.svg";